// Loads Swiper (JS + CSS) from CDN on demand.
// MUST be included in <head> WITHOUT defer so sections can call it before body parses.
window.swiperCheckAndLoad = function () {
  if (window.swiperCustomLoad && typeof window.Swiper !== "undefined") {
    return Promise.resolve();
  }
  if (window.swiperLoadPromise) return window.swiperLoadPromise;
  window.swiperCustomLoad = true;
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
  document.head.appendChild(link);
  var script = document.createElement("script");
  script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
  window.swiperLoadPromise = new Promise(function (resolve) {
    script.onload = function () { resolve(); };
    script.onerror = function () { resolve(); };
  });
  document.head.appendChild(script);
  return window.swiperLoadPromise;
};

